/*
 * @Description: 时间起止
 * @Date: 2025-02-18 17:00:08
 */
import { DefineComponent } from 'vue';
import _BizInput from './src/views/biz-form-times.vue';

type Props = {
  label: string;
  startProp: string;
  endProp: string;
  // style type rules都写死了，有需要再扩展
};

const BizFormTimes = _BizInput as unknown as DefineComponent<Props>;

export { BizFormTimes as default, Props };
